var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVidisLogoNoTextInverted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_392_12146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.299 12.8224L22.4345 0.00750084L26.5378 12.1773H29.4641L33.5724 0.000488281L30.9868 0.00149008L28.0415 8.86436L25.0662 0.00149008L22.4335 0.00249187V0.000488281L20.0452 0.990261L20.7154 10.3059L14.5754 3.25632L12.1431 4.26412L20.5952 13.9435L23.299 12.8224Z",
    fill: "#d2eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8465 15.7793L12.1422 4.26465L10.314 6.09292L14.4975 14.4429L6.12747 10.2804L4.26514 12.1438L15.7777 17.85L17.8465 15.7793Z",
    fill: "#d2eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9434 20.5977L4.26507 12.1426L3.2753 14.5319L10.3369 20.6448L1.01025 20.0017L0.00244141 22.434L12.8234 23.3016L13.9434 20.5977Z",
    fill: "#d2eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8254 32.705L0.0234791 33.5685L12.1792 29.4702V26.5429L0.00244141 22.4346L0.0034432 25.0212L8.86631 27.9665L0.0034432 30.9418L0.00444499 33.5695L0.0034432 33.5705L0.00444499 33.5715V33.5755L0.00544679 33.5745L0.993216 35.9588L10.3089 35.2876L3.25927 41.4276L4.26708 43.8609L13.9454 35.4078L12.8254 32.705Z",
    fill: "#d2eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7798 38.1553L4.26514 43.8605L6.09341 45.6888L14.4434 41.5043L10.2809 49.8743L12.1442 51.7376L17.8495 40.225L15.7798 38.1553Z",
    fill: "#d2eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6006 42.0601L12.1455 51.7384L14.5348 52.7282L20.6477 45.6655L20.0036 54.9922L22.4369 56.001L23.3045 43.1801L20.6006 42.0601Z",
    fill: "#d2eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7099 43.1786L33.5755 55.9926L29.4721 43.8238H26.5449L22.4365 56.0006L25.0222 55.9996L27.9684 47.1367L30.9428 55.9986H33.5755V56.0006L35.9637 55.0108L35.2935 45.6941L41.4335 52.7447L43.8669 51.7369L35.4138 42.0576L32.7099 43.1786Z",
    fill: "#d2eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1641 40.2216L43.8693 51.7372L45.6976 49.9079L41.5131 41.558L49.883 45.7214L51.7464 43.8581L40.2328 38.1519L38.1641 40.2216Z",
    fill: "#d2eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0069 33.5653L43.1859 32.6987L42.0669 35.4026L51.7452 43.8577L52.734 41.4684L45.6724 35.3555L54.999 35.9986L56.0069 33.5653Z",
    fill: "#d2eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1845 23.2961L55.9864 22.4326L43.8306 26.5309L43.8316 29.4571L56.0074 33.5655V30.9799L47.1445 28.0346L56.0064 25.0593V22.4306H56.0074L56.0064 22.4286V22.4256H56.0054L55.0176 20.0423L45.701 20.7125L52.7516 14.5725L51.7438 12.1401L42.0645 20.5923L43.1845 23.2961Z",
    fill: "#d2eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2269 17.845L51.7425 12.1408L49.9133 10.3125L41.5633 14.496L45.7268 6.12601L43.8624 4.26367L38.1572 15.7763L40.2269 17.845Z",
    fill: "#d2eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4104 13.9415L43.8645 4.26312L41.4762 3.27335L35.3623 10.335L36.0064 1.00829L33.5731 0.000488281L32.7065 12.8214L35.4104 13.9415Z",
    fill: "#d2eeff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_392_12146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.0046,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVidisLogoNoTextInverted);
export default __webpack_public_path__ + "static/media/VidisLogoNoTextInverted.33f7c9ed2e7cf67377cd6f07f02d1103.svg";
export { ForwardRef as ReactComponent };